import React, { useState } from 'react';
import './Modal.css';
import './SaveAnalysisModal.css';

const SaveAnalysisModal = ({ isOpen, onClose, onSave, loading }) => {
  const [analysisName, setAnalysisName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!analysisName.trim()) {
      setError('Please enter an analysis name');
      return;
    }

    onSave(analysisName.trim());
  };

  const handleClose = () => {
    setAnalysisName('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay save-analysis-modal" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Save Analysis</h2>
          <button className="modal-close" onClick={handleClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <p className="modal-description">
              Enter a name for this analysis to save it for later reference.
            </p>

            <div className="form-group">
              <label htmlFor="analysis-name">Analysis Name</label>
              <input
                id="analysis-name"
                type="text"
                value={analysisName}
                onChange={(e) => {
                  setAnalysisName(e.target.value);
                  setError('');
                }}
                placeholder="e.g., Edinburgh City Centre July 2025"
                maxLength={255}
                disabled={loading}
                autoFocus
              />
              {error && <div className="form-error">{error}</div>}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Analysis'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SaveAnalysisModal;
